module.exports = __webpack_public_path__ + "static/sound-be100d6e05a04b510ff531ecd49c00df.png";